export default __webpack_public_path__ + "static/media/G_D_btn_lego.d62e7fe9.svg";